import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main/Main';

export const Personalization = () => (
  <>
    <DocumentHead title='Personalization' />
    <PageTemplate main={<Main />} />
  </>
);
